import React from 'react';
import {Form} from "react-bootstrap";
import classnames from 'classnames';

import './toggleswitch.scss';

export default function ToggleSwitch ({textClasses, label1 = undefined, label2, isChecked, onChange, id}) {
	return (
		<div className="toggleswitch">
			{ label1 ? <p className={classnames([textClasses])}>{label1}</p> : null }
			<Form.Check
				type="switch"
				onChange={onChange}
				checked={isChecked}
				id={id}
			/>
			<p className={classnames([
				textClasses,
				// { active: isChecked }
				])}
			>{label2}</p>
		</div>
	)
}